import { render, staticRenderFns } from "./CustomRusica1LabelType3.vue?vue&type=template&id=1c3d14fe&"
import script from "./CustomRusica1LabelType3.vue?vue&type=script&lang=js&"
export * from "./CustomRusica1LabelType3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports